import React, { Component } from 'react';
import '../styles/Laboratorio.css';
import laboratorioImage from '../images/labs/laboratorio-banner.png'
import Banner from './Banner'
import CardSection from './CardSection'
import ScrollTop from './ScrollTop'
import Analytics from './Analytics'

class Laboratorio extends Component {
    render() {
        return (
            <div className="Laboratorio">
                <ScrollTop />
                <Analytics />
                <Banner className="banner-laboratorio" imageBanner={laboratorioImage} title="Laboratorios" description="Trabaje usted también junto a los líderes"/>
                <div class="card-lab">
                    <CardSection classContainer="card-lab"/>
                </div>
            </div>
        );
    }
}

export default Laboratorio;


// WEBPACK FOOTER //
// ./src/components/Laboratorio.js